<template lang="pug">
  span
    template(v-if="currency == 'USD'")
      i.flag-icon.flag-icon-us.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'THB'")
      i.flag-icon.flag-icon-th.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'IDR'")
      i.flag-icon.flag-icon-id.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'VND'")
      i.flag-icon.flag-icon-vn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CNY'")
      i.flag-icon.flag-icon-cn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'HKD'")
      i.flag-icon.flag-icon-hk.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KRW'")
      i.flag-icon.flag-icon-kr.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'AUD'")
      i.flag-icon.flag-icon-au.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'INR'")
      i.flag-icon.flag-icon-in.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MMK' || currency == 'MMO'")
      //- i.flag-icon.flag-goo.mr-1
      i.flag-icon.flag-icon-mm.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BDT'")
      i.flag-icon.flag-icon-bd.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'EUR'")
      i.flag-icon.flag-icon-eu.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'TND'")
      i.flag-icon.flag-icon-tn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'ARS'")
      i.flag-icon.flag-icon-ar.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BND'")
      i.flag-icon.flag-icon-bn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'GOO'")
      i.flag-icon.flag-goo.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PKR'")
      i.flag-icon.flag-icon-pk.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'UST'")
      i.flag-icon.flag-usdt.align-middle.mr-1
      span #[b USDT ]
    template(v-else-if="currency == 'LAK'")
      i.flag-icon.flag-icon-la.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'JPY'")
      i.flag-icon.flag-icon-jp.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NPR'")
      i.flag-icon.flag-icon-np.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BRL'")
      i.flag-icon.flag-icon-br.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'LKR'")
      i.flag-icon.flag-icon-lk.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PHP'")
      i.flag-icon.flag-icon-ph.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MNT'")
      i.flag-icon.flag-icon-mn.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'SGD'")
      i.flag-icon.flag-icon-sg.align-middle.mr-1
      span #[b {{ currency }} ]

    template(v-else-if="currency == 'KHR'")
      i.flag-icon.flag-icon-kh.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'AED'")
      i.flag-icon.flag-icon-ae.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CAD'")
      i.flag-icon.flag-icon-ca.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CHF'")
      i.flag-icon.flag-icon-ch.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'DKK'")
      i.flag-icon.flag-icon-dk.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'GBP'")
      i.flag-icon.flag-icon-gb.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MXN'")
      i.flag-icon.flag-icon-mx.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NGN'")
      i.flag-icon.flag-icon-ng.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NOK'")
      i.flag-icon.flag-icon-no.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NZD'")
      i.flag-icon.flag-icon-nz.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'RUB'")
      i.flag-icon.flag-icon-ru.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'SEK'")
      i.flag-icon.flag-icon-se.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'TRY'")
      i.flag-icon.flag-icon-tr.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'ZAR'")
      i.flag-icon.flag-icon-za.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'COP'")
      i.flag-icon.flag-icon-co.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PEN'")
      i.flag-icon.flag-icon-pe.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KES'")
      i.flag-icon.flag-icon-ke.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PGK'")
      i.flag-icon.flag-icon-pg.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'SAR'")
      i.flag-icon.flag-icon-sa.align-middle.mr-1
      span #[b {{ currency }} ]
    template(v-else)
      i.flag-icon.flag-icon-my.align-middle.mr-1
      span #[b {{ currency }} ]
</template>

<script>
export default {
  props: {
    currency: ""
  }
}
</script>

<style lang="scss" scoped>
.flag-goo {
  background-image: url("/assets/img/goo.png");
  width: 18px;
  height: 14px;
}

.flag-usdt {
  background-image: url("/assets/img/usdt.png");
  width: 18px;
  height: 14px;
}
</style>
